export const NAVIGATION_BAR_HEIGHT = 80;

export const DARK_SCHEME_COLOR_BACKGROUND = '#1c1c1e';
export const DARK_SCHEME_COLOR = '#DDDDDD';

export const BUTTON_COLOR = '#9F8875';
export const BUTTON_HOVER_COLOR = '#B6A08D';

export const BUTTON_COLOR_BULLET = "#091842";
export const BUTTON_HOVER_COLOR_BULLET = "#102B74";